export default function StatsSection() {
  const stats = [
    { value: '10,000+', label: '漫画资源', icon: 'ri-book-2-line' },
    { value: '50万+', label: '每日活跃读者', icon: 'ri-user-heart-line' },
    { value: '99.9%', label: '服务稳定性', icon: 'ri-shield-check-line' },
    { value: '6大', label: '漫画分类', icon: 'ri-layout-grid-line' },
  ];

  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            为什么选择韩漫网
          </h2>
          <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto">
            专业漫画阅读平台，用心服务每一位读者
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="text-center animate-slide-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
                <i className={`${stat.icon} text-xl md:text-2xl text-background-50`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}